let datadogRumInstance = null;
const pendingGlobalContext = new Map(); // Store global context properties until datadogRum is loaded

export function loadDataDogRum() {
  return import('@datadog/browser-rum')
    .then(({ datadogRum }) => {
      try {
        datadogRum.init({
          applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
          clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
          env: import.meta.env.VITE_ENV,
          version: import.meta.env.VITE_VERSION,
          service: import.meta.env.VITE_SERVICE,
          allowedTracingOrigins: [new URL(import.meta.env.VITE_ACQ_APP_APPLY_BFF_URL).origin],
          trackUserInteractions: true, // Used to enable Heatmap capture
          sessionSampleRate: 100,
          sessionReplaySampleRate: import.meta.env.VITE_ENV === 'prod' ? 100 : 0,
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error initializing Datadog RUM', error);
        return;
      }

      datadogRumInstance = datadogRum;

      pendingGlobalContext.forEach((value, key) => {
        datadogRum.setGlobalContextProperty(key, value);
      });
      pendingGlobalContext.clear();
    })
    .catch(error => {
      // eslint-disable-next-line no-console
      console.error('Error loading Datadog RUM', error);
    });
}

export function setGlobalContextProperty(key, value) {
  if (datadogRumInstance?.setGlobalContextProperty) {
    datadogRumInstance.setGlobalContextProperty(key, value);
    return;
  }
  pendingGlobalContext.set(key, value);
}

const dataDogContextKeys = [
  'applicationId',
  'applicationRef',
  'latitudeId',
  'isResuming',
  'isResumed',
  'productCode',
  'countryCode',
  'oktaProfileHealthy',
];

export const storeToDataDogGlobalContext = storeState => {
  setGlobalContextProperty('usr.id', storeState.latitudeId);

  dataDogContextKeys.forEach(key => {
    setGlobalContextProperty(key, storeState[key]);
  });
};
